import React from 'react';


class Date extends React.Component {
	
	constructor(props) {

		super(props);

		this.dayInputRef = null;
		this.monthInputRef = null;
		this.yearInputRef = null;
		
		

		
	}



	
    componentDidMount = () => {
		this.focusDayInput();
    }
	
    componentDidUpdate = () => {
    }
	
	focusDayInput = () => {
		// Focus the text input using the raw DOM API      
		if (this.dayInputRef && this.dayInputRef.focus) this.dayInputRef.focus();
	};
	focusMonthInput = () => {
		// Focus the text input using the raw DOM API      
		if (this.monthInputRef && this.monthInputRef.focus) this.monthInputRef.focus();
	};
	focusYearInput = () => {
		// Focus the text input using the raw DOM API      
		if (this.yearInputRef && this.yearInputRef.focus) this.yearInputRef.focus();
	};

	setDayInputRef = (element) => {
		this.dayInputRef = element;
	};
	setMonthInputRef = (element) => {
		this.monthInputRef = element;
	};
	setYearInputRef = (element) => {
		this.yearInputRef = element;
	};

	render = () => {

        //console.log('props', this.props); onClick={this.props.onCalculate}

		return (
			<form className={"sum"} >
				<h1>Твой ЦИФРОВОЙ НАВИГАТОР</h1>
				<h2>Введите данные</h2>
				<div className={"inputs"}>
					<input type="text" placeholder="дд" value={this.props.birthDayInput} onChange={ (e) => {this.props.onChangeBirthDay(e, this.focusMonthInput)} } ref={this.setDayInputRef} />
					<input type="text" placeholder="мм" value={this.props.birthMonthInput} onChange={ (e) => {this.props.onChangeBirthMonth(e, this.focusYearInput)} } ref={this.setMonthInputRef} />
					<input type="text" placeholder="гггг" value={this.props.birthYearInput} onChange={this.props.onChangeBirthYear} ref={this.setYearInputRef} />
      			</div>
				<button className={"button"} type="button" onClick={this.props.onCalculate}>
					Рассчитать
				</button>
    		</form>
		);
	}

}

export default Date;
